export default {
  props: {
    /**
     * Applies button base styling.
     */
    button: {
      type: Boolean,
      default: true,
    },
    /**
     * Primary button styling.
     */
    primary: {
      type: Boolean,
      default: false,
    },
    /**
     * Secondary button styling.
     */
    secondary: {
      type: Boolean,
      default: false,
    },
    /**
     * Tertiary button styling.
     */
    tertiary: {
      type: Boolean,
      default: false,
    },
    /**
     * Vibrant button styling.
     */
    vibrant: {
      type: Boolean,
      default: false,
    },
    /**
     * Alert button styling.
     */
    alert: {
      type: Boolean,
      default: false,
    },
    /**
     * Text button styling (must be paired with `underline` prop).
     */
    text: {
      type: Boolean,
      default: false,
    },
    /**
     * Text button styling (must be paired with `text` prop).
     */
    underline: {
      type: Boolean,
      default: false,
    },
    /**
     * Adds an icon to the left of the text label.
     */
    icon: {
      type: String,
    },
    /**
     * Positions icon to the right of text label.
     */
    iconRight: {
      type: Boolean,
      default: false,
    },
    /**
     * Displays only an icon (no text label).
     */
    iconOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * X-Small size button.
     */
    xsmall: {
      type: Boolean,
      default: false,
    },
    /**
     * Small size button.
     */
    small: {
      type: Boolean,
      default: false,
    },
    /**
     * Pill/Rounded button.
     */
    pill: {
      type: Boolean,
      default: false,
    },
    /**
     * Full width button.
     */
    block: {
      type: Boolean,
      default: false,
    },
    /**
     * Inverted button styling.
     */
    inverted: {
      type: Boolean,
      default: false,
    },
    /**
     * Inline button (paired with form inputs).
     */
    formInline: {
      type: Boolean,
      default: false,
    },
    /**
     * Success button styling.
     */
    success: {
      type: Boolean,
      default: false,
    },
    /**
     * Success icon styling.
     */
    iconSuccess: {
      type: Boolean,
      default: false,
    },
    /**
     * Warning icon styling.
     */
    iconWarning: {
      type: Boolean,
      default: false,
    },
    /**
     * Alert icon styling.
     */
    iconAlert: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses() {
      return {
        button: this.button,
        'button--primary': this.button && this.primary,
        'button--secondary': this.button && this.secondary,
        'button--tertiary': this.button && this.tertiary,
        'button--vibrant': this.button && this.vibrant,
        'button--text': this.button && this.text,
        'button--success': this.button && this.success,
        'button--alert': this.button && this.alert,
        'button--inverted': this.button && this.inverted,
        'button--icon': this.button && this.icon && !this.text && !this.iconOnly,
        'button--icon-right': this.button && this.iconRight,
        'button--icon-only': this.button && this.iconOnly,
        'button--xs text-xs': this.button && this.xsmall,
        'button--sm text-sm': this.button && this.small,
        'text-md': this.button && !this.xsmall && !this.small,
        'w-full mx-0': this.button && this.block,
        'button--underline': this.button && this.text && this.underline,
        'button--inline': this.button && this.formInline,
        'button--pill': this.button && this.pill,
      };
    },
  },
};
